import React from 'react'

import { Box } from 'widgets/Box'
import { Text } from 'widgets/Text'

import { UserType } from 'types/user'

type BlockedUserProps = {
  user: UserType | null | undefined
  isCurrentUser: boolean
}

export const BlockedUser = ({ user, isCurrentUser }: BlockedUserProps) => {
  if (!user) return null

  return (
    <Box
      margin='lg'
      padding='md'
      border={{ width: 2, color: 'primary' }}
      borderRadius='md'
      backgroundColor='grey'
    >
      {!isCurrentUser ? (
        <Text fontSize='lg' align='center'>
          <Text bold fontSize='lg'>
            @{user?.username}
          </Text>{' '}
          is blocked
        </Text>
      ) : (
        <Text fontSize='lg' align='center'>
          You&apos;re blocked
        </Text>
      )}
      <Box margin={{ top: 'md' }}>
        <Text>You will not be able to see any of this user&apos;s posts or chat with them.</Text>
      </Box>
    </Box>
  )
}
